//= ../../node_modules/jquery/dist/jquery.js
//= ../../node_modules/svg4everybody/dist/svg4everybody.js
//= ../../node_modules/vanilla-lazyload/dist/lazyload.min.js
//= ../../node_modules/jquery-bootstrap-scrolling-tabs/dist/jquery.scrolling-tabs.min.js
//= ../../node_modules/owl.carousel/dist/owl.carousel.js
//= ../../node_modules/micromodal/dist/micromodal.js

/* tabs */
//= ../../node_modules/bootstrap/js/dist/tab.js

//= jquery.vticker.min.js





/* common functions */
function throttle (func, interval) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function () {
            timeout = false;
        };
        if (!timeout) {
            func.apply(context, args)
            timeout = true;
            setTimeout(later, interval)
        }
    }
}

var windowWidth = $(window).width();

/* init vTicker */
$(function() {
    var mainPromo = $('#main-promo');

    if (mainPromo.length) {
        mainPromo.vTicker();
    }
});

/* init and upd lazy-load */
var ll;
function actualLazyLoad() {
    function logElementEvent(eventName, element) {
        element.getAttribute("data-bg")
    }

    var callback_error = function (element) {
        element.src =
            "https://via.placeholder.com/440x560/?text=Error+Placeholder";
    };
    var callback_loaded = function (element) {

    };

    ll = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 0,
        callback_loaded: callback_loaded,
        callback_error: callback_error
    });
}
setTimeout(actualLazyLoad, 2000);


/* Cross-browser svg compatibility */
$(document).ready(function () {
    svg4everybody({});
});


/* init modal windows */
MicroModal.init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
});


/* ========== Header ========== */
/* burger-menu */
function burgerMenu() {
    var burgerBtn = $('.page-header .burger-menu'),
        burgerDropdown = $('.page-header .nav-list');

    burgerBtn.on('click', function(e) {
        e.stopPropagation();

        if (burgerDropdown.hasClass('show')) {
            burgerDropdown.removeClass('show');
            $(this).removeClass('opened');
        } else {
            burgerDropdown.addClass('show');
            $(this).addClass('opened');
        }
    });

    $(document).click(function() {
        burgerDropdown.removeClass('show');
        burgerBtn.removeClass('opened');
    });
}
burgerMenu();

/* search in header */
function searchInHeaderMobile() {
    var toggleBtn = $('.page-header .search-form_btn'),
        headerSearchMobile = $('#header-search-form');

    toggleBtn.on('click', function() {
        if (headerSearchMobile.hasClass('show')) {
            headerSearchMobile.removeClass('show');
        } else {
            headerSearchMobile.addClass('show');
        }
    });

    $(document).mouseup(function(e) {
        if (!headerSearchMobile.is(e.target) && headerSearchMobile.has(e.target).length === 0 && !toggleBtn.is(e.target) && toggleBtn.has(e.target).length === 0) {
            headerSearchMobile.removeClass('show');
        }
    });
}
searchInHeaderMobile();

/* change header on scroll */
var mainPage = $('.wrapper.main-page');
var headerScroll = throttle(function() {
    var header = $('.page-header'),
        headerPosition = header.offset().top,
        headerHeight = header.height(),
        scrolledEl = $('.search-promo-section'),
        scrolledElHeight = scrolledEl.outerHeight();

    if ((headerPosition + headerHeight) > scrolledElHeight) {
        header.removeClass('main').addClass('default');
    } else {
        header.removeClass('default').addClass('main');
    }
}, 100);
if (mainPage.length) {
    console.log('scroll')
    window.addEventListener('scroll', headerScroll);
}
/* ========== Header ========== */

/* ========== Footer ========== */
$(function () {
    var $footerList = $('.site-map-container .map-item .list-title');
    $footerList.click(function (e) {
        if ($(window).width() <= '640') {
            var current = $(this).closest('.map-item').find('.footer-list');
            current.slideToggle();

            $(this).toggleClass('active');
        }
    });
});
/* ========== Footer ========== */

/* btn to top */
(function($) {
    "use strict";

    jQuery(window).scroll(function(){
        if (jQuery(this).scrollTop() > 1) {
            jQuery('.dmtop').css({bottom:"10px"});
        } else {
            jQuery('.dmtop').css({bottom:"-100px"});
        }
    });
    jQuery('.dmtop').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 800);
        return false;
    });
})(jQuery);


/* ========= MAIN PAGE ======== */
/* ------- owl-carousels ------ */
var mainPageSliders = $('.slider-main-page'),
    blogSettings = {
        items: 3,
        nav: true,
        loop: true,
        dots: false,
        navText: ['<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-left"></use></svg>', '<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-right"></use></svg>'],
        responsive:{
            0:{
                items:1
            },
            768:{
                items:2
            },
            1025:{
                items:3
            }
        }
    },
    appsSettings = {
        items: 4,
        nav: true,
        loop: true,
        dots: false,
        navText: ['<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-left"></use></svg>', '<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-right"></use></svg>'],
        responsive:{
            0:{
                items:1
            },
            481:{
                items:2
            },
            768:{
                items:3
            },
            1025:{
                items:4
            }
        }
    };

$(document).ready(function() {
    mainPageSliders.each(function() {
        if ($(this).hasClass('blog')) {
            $(this).owlCarousel(blogSettings)
        } else if ($(this).hasClass('app')) {
            $(this).owlCarousel(appsSettings)
        }
    });
});


/* resized owl-carousel */
function resizedCarousel() {
    var resizedCarousel = $('.resized-carousel'),
        windowWidth = $(window).width(),
        id;

    if (windowWidth < 1025) {
        resizedCarousel.owlCarousel(appsSettings);
    }
    if (windowWidth >= 1025) {
        resizedCarousel.trigger('destroy.owl.carousel');
    }
}
resizedCarousel();
$(window).resize(resizedCarousel);

/* ========= MAIN PAGE ======== */


/* ======== PRODUCT PAGE ====== */
/* --------- jQuery Scrolling Tabs ------- */
$('#appPageScrollingTabs').scrollingTabs({
    bootstrapVersion: 4,
    disableScrollArrowsOnFullyScrolled: true,
    enableSwiping: true,
    enableRtlSupport: true,
    scrollToTabEdge: true,
    leftArrowContent: [
        '<div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-left">',
        '<svg class="svg-icons">',
        '    <use xlink:href="/images/svgdefs.svg#angle-left"></use>',
        '</svg>',
        '</div>',
    ].join(''),
    rightArrowContent: [
        '<div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-right">',
        '<svg class="svg-icons">',
        '    <use xlink:href="/images/svgdefs.svg#angle-right"></use>',
        '</svg>',
        '</div>'
    ].join('')
});
$('.product-review-container .nav-tabs').scrollingTabs('scrollToActiveTab');
/* --------- jQuery Scrolling Tabs ------- */


/* ========= modal windows ======== */
function tabsFunction() {
    var tabBtns = $('.tabs > li');

    tabBtns.on('click', function() {
        var id = $(this).attr('data-tab'),
            content = $('.tab-content > li[data-tab="'+ id +'"]');

        $('.tabs > li.active').removeClass('active');
        $(this).addClass('active');

        $('.tab-content > li.active').removeClass('active');
        content.addClass('active');
    })
}
tabsFunction();

/* reset pass */
function resetPass() {
    var showResetPassFormBtn = $('.login-modal .form-inline .forgot-pass'),
        hiddenForm = $('.login-modal .hide-el'),
        shownForm = $('.login-modal .lost-pass'),
        backToLoginFormBtn = shownForm.find('.forgot-pass');

    showResetPassFormBtn.on('click', function() {
        hiddenForm.addClass('hide');
        shownForm.addClass('active');
    });

    backToLoginFormBtn.on('click', function() {
        hiddenForm.removeClass('hide');
        shownForm.removeClass('active');
    })
}
resetPass();

/* helpful block */
(function () {
    // console.log('helpful');
    var yesButton = $('#buttonYes'),
        noButton = $('#buttonNo'),
        startBlock = $('.question');

    if (yesButton.length > 0) {
        yesButton.on('click', function () {
            var yesBlock = $('.block-yes');
            startBlock.css('display', 'none');
            yesBlock.css('display', 'block');
        });
        noButton.on('click', function () {
            var noBlock = $('.block-no');
            startBlock.css('display', 'none');
            noBlock.css('display', 'block');
        });
    }
})();


/* =========== Other pages ============ */
/* --- our-team --- */
$(document).ready(function() {
    $('.our-team-carousel').owlCarousel({
        margin: 20,
        loop: false,
        nav: true,
        dots: false,
        navText: ['<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-left"></use></svg>', '<svg class="svg-icons"><use xlink:href="images/svgdefs.svg#angle-right"></use></svg>'],
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 2
            },
            641: {
                items: 3
            },
            880: {
                items: 4
            }
        }
    });
});

//= video-modal_main-page.js
//= gdpr-billet.js
//= user-rating.js
//= app-page-video.js
//= new-critic-registration.js
//= careers.js




